import BuyerLayout from "../components/Layout";
import Breadcrumb from "../../SharedComponents/components/Breadcrumb/Breadcrumb";
import AddUserCarInGarageForm from "../forms/AddUserCarInGarageForm";

const AddUserCar = () => {

    const breadcrumbs = [
        { title: "Pocetak", href: "/home" },
        { title: "Dodaj novo vozilo" }
    ];

    return (
        <BuyerLayout>
            <Breadcrumb
                title={"Dodaj novo vozilo"}
                breadcrumbs={breadcrumbs}
            />

            <AddUserCarInGarageForm />
        </BuyerLayout>
    )
};

export default AddUserCar;